














import { Component, Vue } from 'vue-property-decorator'

import BaseLogin from '@/components/common/BaseLogin.vue'

@Component( {
    components: {
        'oe-base-login': BaseLogin
    }
} )
export default class LoginView extends Vue {
}
